import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import ScreenshotDetail from '../../components/ScreenshotDetail';
import './HostingRosterEvidence.css';

const ROSTER_ALT =
  'RidePulse event participant list excerpt showing the first two riders, CanyonRunner and DesertRider, with the motorcycles they are bringing';

/* Two viewBox excerpts of the unchanged original — only one is visible at a
   time. The wide crop carries the RIDERS header plus the first two complete
   entries; the compact crop keeps the same two identities readable on narrow
   panels. The full original retains the complete participant list, including
   privacy-limited rows. */
const HostingRosterEvidence: React.FC = () => {
  const { theme, colors } = useTheme();
  const src = `/assets/screenshots/ios-delivery/snapshots/20261006T002614Z/Event Details/iOS - Event Details - Participants - ${theme === 'dark' ? 'Dark' : 'Light'}.png`;
  return (
    <figure className="hre mx-auto m-0">
      <div className="hre-wide">
        <ScreenshotDetail
          src={src}
          crop={{ x: 48, y: 780, width: 1224, height: 770 }}
          alt={ROSTER_ALT}
          fullImageLabel="View the full participant list"
        />
      </div>
      <div className="hre-compact">
        <ScreenshotDetail
          src={src}
          crop={{ x: 215, y: 995, width: 710, height: 550 }}
          alt={ROSTER_ALT}
          fullImageLabel="View the full participant list"
        />
      </div>
      <figcaption className="mt-3 text-xs text-center" style={{ color: colors.textSecondary }}>
        Riders and motorcycles.
      </figcaption>
    </figure>
  );
};

export default HostingRosterEvidence;
